/**
 * @author Fernando Ruano
 * @file actions.js
 * @description CountryUserRole Actions
 */

// Constants
import {
  GET_ALL_COUNTRY_USER_ROLES,
  CREATE_COUNTRY_USER_ROLE,
  UPDATE_COUNTRY_USER_ROLE,
  GET_COUNTRY_USER_ROLE_BY_ID,
  DELETE_COUNTRY_USER_ROLE_BY_ID
} from './constants';

/**
 * Call process to get all country user roles list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_COUNTRY_USER_ROLES
 */
export const getCountryUserRolesArray = (data, callback) => ({
  type: GET_ALL_COUNTRY_USER_ROLES,
  payload: { data },
  callback
});

/**
 * Call process to get country user role by id
 * @param  { object } data - CountryUserRole Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getCountryUserRoleById = (data, callback) => ({
  type: GET_COUNTRY_USER_ROLE_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create country user role
 * @param  { object } data - CountryUserRole Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_COUNTRY_USER_ROLE
 */
export const createCountryUserRole = (data, callback) => ({
  type: CREATE_COUNTRY_USER_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to update country user role
 * @param  { object } data - CountryUserRole Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_COUNTRY_USER_ROLE
 */
export const updateCountryUserRole = (data, callback) => ({
  type: UPDATE_COUNTRY_USER_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to delete country user role
 * @param  { object } data - CountryUserRole Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_COUNTRY_USER_ROLE
 */
export const deleteCountryUserRoleById = (data, callback) => ({
  type: DELETE_COUNTRY_USER_ROLE_BY_ID,
  payload: { data },
  callback
});
